import React from 'react';
import SubscriptionService from '../../services/subscription';

export default class SubscriptionConfirmPopup extends React.Component {
    constructor(props) {
        super(props);
        this.state = { isLoading: false, error: null, paymentMethodExpired: false };
        this.handleConfirm = this.handleConfirm.bind(this);
    }

    async handleConfirm() {
        const { creatorId, savedCard, onSuccess } = this.props;
        if (!savedCard?.paymentMethodId) return;

        this.setState({ isLoading: true, error: null });
        try {
            const result = await SubscriptionService.create(creatorId, savedCard.paymentMethodId);
            this.setState({ isLoading: false });
            onSuccess(result.data);
        } catch (err) {
            const code = err?.response?.data?.error;
            const detail = err?.response?.data?.detail;
            let msg;
            if (code === '#PaymentMethodExpired') {
                msg = 'This payment method can no longer be used. Please add a new card.';
            } else if (code === '#PaymentFailed') {
                msg = detail ? `Payment failed: ${detail}` : 'Payment failed. Please try a different card.';
            } else {
                msg = 'Something went wrong. Please try again.';
            }
            const needsNewCard = code === '#PaymentMethodExpired' || code === '#PaymentFailed';
            this.setState({ isLoading: false, error: msg, paymentMethodExpired: needsNewCard });
        }
    }

    render() {
        const { publicName, pricePerMonth, savedCard, onCancel, onAddPaymentMethod } = this.props;
        const { isLoading, error, paymentMethodExpired } = this.state;

        return (
            <div className="sub-confirm-backdrop" onClick={isLoading ? null : onCancel}>
                <div className="sub-confirm-popup" onClick={e => e.stopPropagation()}>
                    <div className="sub-confirm-header">
                        <span className="sub-confirm-title">Subscribe to @{publicName}</span>
                        <button className="sub-confirm-close" onClick={onCancel} disabled={isLoading}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
                            </svg>
                        </button>
                    </div>

                    <div className="sub-confirm-price-row">
                        <span className="sub-confirm-price">${pricePerMonth}</span>
                        <span className="sub-confirm-per-month">/ month</span>
                    </div>

                    <div className="sub-confirm-payment-section">
                        <div className="sub-confirm-payment-label">Payment method</div>
                        {savedCard ? (
                            <div className="sub-confirm-card">
                                <span className="sub-confirm-card-brand">{savedCard.brand?.toUpperCase()}</span>
                                <span className="sub-confirm-card-last4">•••• {savedCard.last4}</span>
                            </div>
                        ) : (
                            <button className="sub-confirm-add-card" onClick={onAddPaymentMethod}>
                                + Add Payment Method
                            </button>
                        )}
                    </div>

                    {error && (
                        <div className="sub-confirm-error">
                            {error}
                            {paymentMethodExpired && (
                                <button className="sub-confirm-add-card sub-confirm-add-card--inline" onClick={onAddPaymentMethod}>
                                    Update payment method
                                </button>
                            )}
                        </div>
                    )}

                    <div className="sub-confirm-actions">
                        <button className="sub-confirm-cancel-btn" onClick={onCancel} disabled={isLoading}>
                            Cancel
                        </button>
                        <button
                            className="sub-confirm-pay-btn"
                            onClick={this.handleConfirm}
                            disabled={!savedCard || isLoading}
                        >
                            {isLoading ? 'Processing…' : 'Confirm'}
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}
